// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { MessageProcessorBase } from './MessageProcessorBase';
import { PFixTradingWebhookListResponse } from '../Messages/PFixTradingWebhookListResponse';
import { TradingWebhook, TradingWebhookListResponseMessage } from '@shared/utils/DirectMessages/Webhooks/TradingWebhookListResponseMessage';
export class TradingWebhookListResponseMessageProcessor extends MessageProcessorBase {
    decode(fieldSet) {
        const pfixMessage = new PFixTradingWebhookListResponse(fieldSet);
        const message = new TradingWebhookListResponseMessage();
        for (const tradingWebhook of pfixMessage.tradingWebhooks) {
            message.webhooks.push(new TradingWebhook(tradingWebhook.id, tradingWebhook.name, tradingWebhook.createdAt, tradingWebhook.expireAt));
        }
        return [message];
    }
}
